<template>
  <table class="table table-striped my-4">
    <thead class="thead-dark">
      <tr>
        <th>{{ $t('views.dailyReport.timeSlot') }}</th>
        <th class="table-width-150">{{ $t('views.dailyReport.seatNumber') }}</th>
        <th>{{ $t('common.owner.surName') }}</th>
        <th>{{ $t('common.owner.givenName') }}</th>
        <th>{{ $t('views.dailyReport.accessibilityRequired') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(ticket, index) in ticketsWithSeatNumber()" :key="index">
        <td>{{ formatTicketTime(ticket) }}</td>
        <td class="table-wdith-150">{{ ticket.seatNumber }}</td>
        <td>{{ ticket.lastName }}</td>
        <td>{{ ticket.firstName }}</td>
        <td>{{ ticket.accessibility ? $t('common.true') : $t('common.false') }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { Ticket } from '@/generated/openapi';
import { TicketWithSeatNumber } from '@/models/TicketWithSeatNumber';
import { formatTicketTimeOnly } from '@/utils/formatUtils';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'ResultListTicketsDaily',
  props: {
    tickets: {
      type: Array as PropType<Ticket[]>,
      required: true
    },
  },
  data() {
    return {

    }
  },
  methods: {
    ticketsWithSeatNumber(): TicketWithSeatNumber[] {
      let seatNumber = 0;
      let timeSlotGroup: string|undefined = undefined
      return this.tickets.map((ticket) => {
        if (timeSlotGroup === ticket.timeSlotId) {
          seatNumber = seatNumber + 1
        } else {
          timeSlotGroup = ticket.timeSlotId
          seatNumber = 1
        }
        return Object.assign({}, ticket, { seatNumber: seatNumber });
      })
    },
    formatTicketTime(ticket: Ticket) {
      return formatTicketTimeOnly(ticket)
    },
  }
});
</script>
